export const EnvSelector = {
	env: 'dev'
};